<template>
  <div class="vld-parent">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="fullPage"
      :witdh="width"
      :height="height"
      :color="color"
      :background-color="backgroundColor"
      :opacity="opacity"
    ></loading>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  name: 'ProgressBar',
  components: { Loading },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      opacity: 0.7,
      color: '#333333',
      backgroundColor: '#FFFFFF',
      width: 50,
      height: 50,
    };
  },
  methods: {
    loadingStart() {
      this.isLoading = true;
    },
    loadingEnd() {
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.vld-parent {
  position: fixed;
}
</style>
